import { PaymentGateway } from '../../../../../services/exports/Constants';

export default {
  title: 'Napsauta alla olevaa painiketta tarkistaaksesi ja vahvistaaksesi maksutietosi.',
  payment_gateways: {
    [PaymentGateway.Stripe]: {
      description:
        'Teemme yhteistyötä Stripen kanssa maksujen käsittelemiseksi. Stripe on turvallisin maksualusta, jota maailman suurimmat yritykset käyttävät.',
      form: {
        terms_acceptance: {
          label:
            'Jatkamalla hyväksyt <FoodAmigosTerms>palvelusopimuksemme</FoodAmigosTerms> ja <StripeTerms>Stripen yhdistetyn tilin sopimuksen.</StripeTerms>',
        },
      },
      labels: {
        stripe_requirements: 'Stripe tarvitsee vielä alla olevat tiedot tai ei pystynyt vahvistamaan niitä:',
        errors: 'Virheet',
        awaiting_verification: 'Stripe-tiliäsi vahvistetaan',
        awaiting_verification_description:
          'Odotamme, että Stripe saa yrityksesi vahvistuksen valmiiksi. Voit sillä välin tarkastella profiiliasi.',
        details_hint:
          'Stripe tarkistaa nimet, osoitteet ja puhelinnumerot virallisista rekistereistä. Jos jokin on väärin, korjaa se kohdassa Omat tiedot → Henkilötiedot, niin Stripe tarkistaa sen uudelleen. Voit lisätä muut Stripen pyytämät tiedot Stripe-profiilissasi.',
        requirements_hint:
          'Osa näistä on asiakirjoja, kuten henkilöllisyystodistuksesi: lataa ne edellisessä vaiheessa, {{step}}, ja palaa sitten tänne.',
        requirements_hint_profile:
          'Osa näistä on asiakirjoja, kuten henkilöllisyystodistuksesi: lataa ne Stripe-profiilissasi.',
      },
      requirements: {
        of_subject: '{{subject}}: {{detail}}',
        subjects: {
          owner: 'Omistaja',
          representative: 'Edustaja',
          business: 'Yritys',
        },
        details: {
          first_name: 'Etunimi',
          last_name: 'Sukunimi',
          email: 'Sähköposti',
          phone: 'Puhelinnumero',
          dob: 'Syntymäaika',
          id_number: 'Henkilötunnus',
          nationality: 'Kansalaisuus',
          address: 'Katu ja talon numero',
          city: 'Kaupunki',
          postal_code: 'Postinumero',
          state: 'Osavaltio/alue',
          country: 'Maa',
          id_document: 'Henkilöllisyystodistus',
          proof_of_address: 'Osoitteen todiste',
          job_title: 'Työnimike',
          business_name: 'Yrityksen virallinen nimi',
          tax_id: 'Verotunnus',
          vat_id: 'ALV-tunnus',
          registration_number: 'Rekisteröintinumero',
          website: 'Verkkosivusto',
          industry: 'Toimiala',
          product_description: 'Kuvaus myytävistä tuotteista',
          support_phone: 'Asiakaspalvelun puhelinnumero',
          owners: 'Omistajien vahvistus',
          directors: 'Johtajien vahvistus',
          executives: 'Toimihenkilöiden vahvistus',
          registration_document: 'Elinkeinoilmoitus',
          bank_account: 'Pankkitili maksuja varten',
          business_type: 'Yritysmuoto',
          terms: 'Stripen ehtojen hyväksyntä',
          bank_account_proof: 'Todiste pankkitilin omistajuudesta',
          tax_id_document: 'Y-tunnuksen asiakirja',
        },
      },
    },
    [PaymentGateway.Adyen]: {
      description:
        'Teemme yhteistyötä Adyenin kanssa maksujen käsittelemiseksi. Adyen on yksi turvallisimmista maksualustoista, jota maailman suurimmat yritykset käyttävät.',
    },
  },
  labels: {
    verified: '{{paymentGateway}}-tilisi on vahvistettu',
    verified_description:
      'Vahvistus on valmis palvelulle {{paymentGateway}}. Voit silti hallita profiiliasi tarvittaessa.',
  },
  buttons: {
    proceed: 'Vahvista maksutietoni',
    copy_link: 'Kopioi linkki',
    back: 'Takaisin',
  },
  toasts: {
    something_went_wrong: 'Jokin meni pieleen, ota yhteyttä tekniseen tukeen',
  },
};
